import { defineStore } from "pinia";
import { Service } from "../types/service.type";
import { Employee } from "../types/employee.type";

interface GlobalStore {
  services: Service[];
  employees: Employee[];
  error: boolean;
  errorMessage: string;
  notice: boolean;
  noticeMessage: string;
  waitListRefreshToken: number;
}

export const useGlobalStore = defineStore("globalStore", {
  state: (): GlobalStore => ({
    services: [],
    employees: [],
    error: false,
    errorMessage: "",
    notice: false,
    noticeMessage: "",
    waitListRefreshToken: 0,
  }),
  persist: {
    paths: ["services", "employees"],
  },
  actions: {
    triggerError(errorMessage: string) {
      this.error = true;
      this.errorMessage = errorMessage;

      setTimeout(() => {
        this.error = false;
        this.errorMessage = "";
      }, 5000);
    },
    triggerNotice(noticeMessage: string) {
      this.notice = true;
      this.noticeMessage = noticeMessage;

      setTimeout(() => {
        this.notice = false;
        this.noticeMessage = "";
      }, 5000);
    },
    // Bumped whenever a push notification implies the wait-list is stale
    // (e.g. a new reservation came in) - components watch this value instead
    // of polling, since the notification can arrive from any tab/page.
    bumpWaitListRefresh() {
      this.waitListRefreshToken += 1;
    }
  }
});
